import type { InferObjectType } from "@/types/InferObjectType";
import type AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import type { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import type { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";
import type { Observable } from "rxjs";
import type { ComponentType } from "svelte";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import type { RewardsWidgetsPlaceholdersType } from "./constants/constants";
import type { REWARDS_STORE_UPDATE_STRATEGY } from "./constants/storeUpdateStrategy";
import type { LazyComponent } from "./lib/RewardsLazyComponent/types";
import type { REWARDS_REFERRAL_SHARE_CHANNELS_TYPE } from "./modules/ReferralProgram/types";

export interface RouteObject {
    path: string;
    children: LazyComponent<ComponentType>;
    fallback: ComponentType | null;
}

export type ReferralShareConfig = {
    channelType: REWARDS_REFERRAL_SHARE_CHANNELS_TYPE;
};

export enum REWARDS_ICON_SIZES {
    extraSmall = "xs", // 60x60
    small = "sm", // 160x160
    medium = "md", // 360x180
    large = "lg", // 720x360
    extraLarge = "xlg", // 1024x768
}

export interface RewardsWidgetInjectorConfig {
    placeholderSelector: RewardsWidgetsPlaceholdersType;
    logger: LoggerInterface;
    eventsCollector: AnalyticsEventsCollectorInterface;
    eventsFactory: AnalyticsEventsFactory;
    dynamicImportManager: DynamicImportManager;
    mutationObserverInjector: MutationObserverInjector;
}

export type RewardsInjectorDefinition = {
    shopConditions: Array<Observable<boolean>>;
    designModeConditions?: Array<Observable<boolean>>;
    startInjector: () => void;
    injectInDesignMode: boolean;
};

export type REWARDS_STORE_UPDATE_STRATEGY_TYPE = InferObjectType<
    typeof REWARDS_STORE_UPDATE_STRATEGY
>;
